export enum Country {
    FR = 'FR',
    EN = 'EN',
    DE = 'DE',
    ES = 'ES',
    BE = 'BE',
    MC = 'MC',
}
